export class CheckboxState {

  public static checked = 'checked';
  public static mixed =  'mixed';
  public static empty = 'empty';

  public static toggle(checkboxState: string): string {
    // toggle:
    // mixed   => checked
    // checked => empty
    // empty   => checked
    switch (checkboxState)
    {
      case CheckboxState.checked: {
        return CheckboxState.empty;
      }
      default: {
        return CheckboxState.checked;
      }
    }
  }
}
